import { Slot } from 'zens-router'
import { PageLayout } from '@dms/component'

export default function Auth() {
  return (
    <PageLayout>
      <Slot />
    </PageLayout>
  )
}
